export type GraduateStaffKind = 'GraduateEvaluator' | 'GraduateFaculty';

const key = 'graduationGraduateStaffKind';
const listeners = new Set<() => void>();
const read = (): GraduateStaffKind => sessionStorage.getItem(key) === 'GraduateFaculty' ? 'GraduateFaculty' : 'GraduateEvaluator';

export const GraduateStaffModeStore = {
  get: read,
  set(kind: GraduateStaffKind) {
    if (read() === kind) return;
    sessionStorage.setItem(key, kind);
    listeners.forEach(listener => listener());
  },
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};
